import api from '@/api/api.js'

export default {
    /**
     * Recupère les soins et hospitalisation en cours
     * @returns 
     */
    getPrescriptionsEnCours() {
        const promise = api.clinique().get('/ordonnances/prescriptions')
        return promise.then(response => response.data)
    },


}